import { StateCreator } from "zustand";
import { Page } from "../../context/AppProvider";

export interface PageSlice {
  page: Page;
  setPage: (page: Page) => void;
}

const createPageSlice: StateCreator<PageSlice, [], [], PageSlice> = (set) => ({
  page: Page.HOME,
  setPage: (page: Page) => set({ page }),
});

export default createPageSlice;
